module.exports = __webpack_public_path__ + "img/okx_new.e86b1a5c.svg";